module.exports = __webpack_public_path__ + "img/circle.c6063de5.png";